/**
* @ngdoc directive
* @name Stop Click Propagation
*
* @description Stop click event propagation
*
*/

(function() {
  'use strict';

  app.directive('stopClickPropagation', directive);

  function directive() {
    return {
      restrict: 'A',
      link: function ($scope, $element) {
        $element.bind('click', function (e) {
          e.stopPropagation();
        });
      }
    };
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/stopClickPropagationDirective.js